import { VStack } from "apps/commons/components/Stack";
import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { profileBinder } from "libs/analytics/binders/onboarding/profile";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { OneOnboardingSkeleton } from "../Skeleton";
import { Title } from "../Title";
import { ProfileForm } from "../form/ProfileForm";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { useProfileDataApi } from "./useProfileDataApi";

export const ProfilePage = () => {
    const {
        cmsData: {
            profile: { profile },
        },
    } = useStaticDataAtomValue();
    const { data, isLoading } = useProfileDataApi();

    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(profileBinder);

    const page = (
        <VStack gap="24" pb="32">
            <Title title={profile} />
            {isLoading ? <OneOnboardingSkeleton /> : <ProfileForm data={data} />}
        </VStack>
    );

    return createPortal(page, document.querySelector("#one-onboarding-portal"));
};
